var _rect, _path, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#00A0AE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6666 20.6666H32.3333C36.733 20.6666 38.9329 20.6666 40.2997 22.0335C41.6666 23.4003 41.6666 25.6002 41.6666 30C41.6666 34.3997 41.6666 36.5996 40.2997 37.9665C38.9329 39.3333 36.733 39.3333 32.3333 39.3333H27.6666C23.2668 39.3333 21.0669 39.3333 19.7001 37.9665C18.3333 36.5996 18.3333 34.3997 18.3333 30C18.3333 25.6002 18.3333 23.4003 19.7001 22.0335C21.0669 20.6666 23.2668 20.6666 27.6666 20.6666ZM31.4583 26.5C31.4583 26.0167 31.85 25.625 32.3333 25.625H38.1666C38.6498 25.625 39.0416 26.0167 39.0416 26.5C39.0416 26.9832 38.6498 27.375 38.1666 27.375H32.3333C31.85 27.375 31.4583 26.9832 31.4583 26.5ZM32.6249 30C32.6249 29.5167 33.0167 29.125 33.4999 29.125H38.1666C38.6498 29.125 39.0416 29.5167 39.0416 30C39.0416 30.4832 38.6498 30.875 38.1666 30.875H33.4999C33.0167 30.875 32.6249 30.4832 32.6249 30ZM33.7916 33.5C33.7916 33.0167 34.1833 32.625 34.6666 32.625H38.1666C38.6498 32.625 39.0416 33.0167 39.0416 33.5C39.0416 33.9832 38.6498 34.375 38.1666 34.375H34.6666C34.1833 34.375 33.7916 33.9832 33.7916 33.5ZM28.8333 26.5C28.8333 27.7886 27.7886 28.8333 26.4999 28.8333C25.2113 28.8333 24.1666 27.7886 24.1666 26.5C24.1666 25.2113 25.2113 24.1666 26.4999 24.1666C27.7886 24.1666 28.8333 25.2113 28.8333 26.5ZM26.4999 35.8333C31.1666 35.8333 31.1666 34.7886 31.1666 33.5C31.1666 32.2113 29.0772 31.1666 26.4999 31.1666C23.9226 31.1666 21.8333 32.2113 21.8333 33.5C21.8333 34.7886 21.8333 35.8333 26.4999 35.8333Z",
    fill: "#EEE82C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 56,
    height: 56,
    rx: 28,
    stroke: "#CCECEF",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.1d465e924c897dde735435966e7dd580.svg";
export { ForwardRef as ReactComponent };